import React, { useState } from 'react';
import { Navigate, useParams } from "react-router-dom";
import Grid from '@mui/material/Grid2';

import RollableTableInput from "@dndComponents/other/RollableTableInput";

export default function RollableTableEdit() {
  const { id } = useParams();
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  
  if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else { 
    let use_id = id;
    if (!use_id) {
      use_id = "New";
    }
    return (
      <Grid container spacing={0} direction="column">
        <RollableTableInput
          rollable_table_id={use_id}
          height={110}
          onChange={() => {
            setNavigateTo("/dandd/rollable_table");
          }}
          onCancel={() => {
            setNavigateTo("/dandd/rollable_table");
          }}
        />
      </Grid>
    );
  }
}